import React from 'react'
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  CircularProgress,
  Box,
  Typography,
} from '@mui/material'

export interface DialogComponentProps {
  isOpen?: boolean
  title?: string
  handleClose?: () => void
  handleConfirmation?: () => void
  isLoading?: boolean
  formIsValid?: boolean
  children?: any
  showCloseButton?: boolean
  closeButtonText?: string
  acceptButtonText?: string
  formIsInValidMessage?: string
  isSubmitting?: boolean
}

export const DialogComponent = (props: DialogComponentProps) => {
  return (
    <Dialog
      open={props.isOpen || false}
      onClose={props.handleClose}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'>
      <DialogTitle id='alert-dialog-title'>{props.title}</DialogTitle>
      {props.isLoading ? (
        <DialogContent>
          <Box
            sx={{
              display: 'flex',
              height: '40px',
              alignContent: 'center',
              ustifyContent: 'center',
            }}>
            <CircularProgress />
          </Box>
        </DialogContent>
      ) : (
        <>
          <DialogContent>
            {props.children}
            <Typography
              color='red'
              paddingBottom={0.5}
              sx={{ whiteSpace: 'pre-wrap' }}>
              {props.formIsInValidMessage}
            </Typography>
          </DialogContent>
          <DialogActions>
            {props.showCloseButton && (
              <Button onClick={props.handleClose}>
                {props.closeButtonText || 'Close'}
              </Button>
            )}
            <Button
              onClick={props.handleConfirmation}
              disabled={!props.formIsValid || props.isSubmitting}
              autoFocus>
              {props.acceptButtonText}
            </Button>
          </DialogActions>
        </>
      )}
    </Dialog>
  )
}
